// Central config for the articles product layer (CTA, email capture, series).
// Email capture posts to Kit (formerly ConvertKit). kitFormId is the numeric
// form id taken from the form's embed action URL:
// https://app.kit.com/forms/<kitFormId>/subscriptions
const ARTICLE_CONFIG = {
	kitFormId: "9696017",
	newsletterName: "the monthly framework",
	newsletterPitch:
		"One field-tested AI governance or leadership framework a month. No hype, no filler.",
	speakingLink: "/contact",
	speakingPitch: "Available for talks and panels on AI governance, AI security, and engineering leadership.",
};

export default ARTICLE_CONFIG;
